import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDialog, {
    attrs: {
      size: "sm",
      "data-qa": "logout-dialog",
      title: _setup.dialogLogout.title,
      attach: "",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
              _vm._v("\n      " + _vm._s(_setup.dialogLogout.text) + "\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _setup.dialogLogout.closeText
              ? _c(
                  VBtn,
                  {
                    attrs: {
                      color: "text",
                      text: "",
                      "data-qa": "logout-dialog-cancel",
                    },
                    on: {
                      click: function ($event) {
                        _setup.isOpened = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.dialogLogout.closeText) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _setup.dialogLogout.confirmText
              ? _c(
                  VBtn,
                  {
                    attrs: {
                      color: "secondary",
                      text: "",
                      "data-qa": "logout-dialog-confirm",
                    },
                    on: { click: _setup.handleConfirm },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.dialogLogout.confirmText) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _setup.isOpened,
      callback: function ($$v) {
        _setup.isOpened = $$v
      },
      expression: "isOpened",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }